// @flow

import React from 'react';
import ViewManager from './ViewManager';


function Viewer() {
  return <ViewManager />;
}

export default Viewer;
